'use client'

import React from 'react'
import { cva } from 'class-variance-authority'
import type { VariantProps } from 'class-variance-authority'
import { cn, warnIfEmptyLabel } from '@/utils'
import { Loading } from '@/icons'

const spinnerVariants = cva(
  'animate-spin animation-duration-[0.8s] text-black',
  {
    variants: {
      size: {
        sm: 'size-3',
        md: 'size-4',
        lg: 'size-6',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)

export type SpinnerProps = {
  size?: VariantProps<typeof spinnerVariants>['size']
  /**
   * Accessible name announced by assistive technologies (e.g. "Loading...").
   * Required — provide a localized string from the consuming app.
   */
  ariaLabel: string
} & Omit<React.ComponentProps<typeof Loading>, 'aria-label'>

export const Spinner = ({
  className,
  size,
  ariaLabel,
  ...props
}: SpinnerProps) => {
  warnIfEmptyLabel(ariaLabel, 'Spinner: ariaLabel')

  return (
    <Loading
      className={cn(spinnerVariants({ size }), className)}
      role="img"
      aria-label={ariaLabel}
      {...props}
    />
  )
}
